<template>
  <div>
    <div class="headline blue--text">"Help" Response</div>

    <v-layout row align-center class="ml-3 mt-3">
      <v-flex xs4 class="align-self-baseline pr-2">
        When a client sends 'HELP' to your texting number, they will be directed to call this number:
      </v-flex>
      <v-flex class="flex-grow-0 flex-shrink-1 pr-2" style="max-width:76px">
        <v-text-field v-model="sync_area"
                      prefix="("
                      suffix=")"
                      mask="###"
                      maxlength="3"
                      hint="area code"
                      persistent-hint
                      class="centered-input"
                      @focus="$event.target.select()">
        </v-text-field>
      </v-flex>
      <v-flex class="flex-grow-0 flex-shrink-1 pr-2" style="max-width:76px">
        <v-text-field v-model="sync_prefix"
                      mask="###"
                      hint="prefix"
                      persistent-hint
                      maxlength="3"
                      class="centered-input"
                      @focus="$event.target.select()">
        </v-text-field>
      </v-flex>
      <v-flex class="flex-grow-0 flex-shrink-1 pr-1">
        -
      </v-flex>
      <v-flex class="flex-grow-0 flex-shrink-1" style="max-width:76px">
        <v-text-field v-model="sync_suffix"
                      mask="####"
                      maxlength="4"
                      hint="suffix"
                      persistent-hint
                      class="centered-input"
                      @focus="$event.target.select()">
        </v-text-field>
      </v-flex>
      <v-flex class="flex-grow-0 flex-shrink-1 pr-1">
        <div v-show="!isValid" class="red--text">A valid 10-digit number is required</div>
      </v-flex>
    </v-layout>

  </div>
</template>

<style scoped>
  .centered-input >>> input {
    text-align: center
  }
</style>

<script>
export default {
  name: 'TSContactNum',
  props: {
    contactNum: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: () => ({
    area: '',
    prefix: '',
    suffix: ''
  }),
  computed: {
    sync_area: {
      get () {
        return this.area;
      },
      set (v) {
        this.area = v;
        this.onChanged();
      }
    },
    sync_prefix: {
      get () {
        return this.prefix;
      },
      set (v) {
        this.prefix = v;
        this.onChanged();
      }
    },
    sync_suffix: {
      get () {
        return this.suffix;
      },
      set (v) {
        this.suffix = v;
        this.onChanged();
      }
    },
    isValid () {
      return this.area.length === 3 && this.prefix.length === 3 && this.suffix.length === 4;
    }
  },
  watch: {
    contactNum () {
      this.area = this.getAreaCode();
      this.prefix = this.getPrefix();
      this.suffix = this.getSuffix();
    }
  },
  methods: {
    onChanged () {
      if (this.isValid) {
        const num = this.area + this.prefix + this.suffix;
        this.$emit('contactNumberChanged', num, true);
      } else {
        this.$emit('contactNumberChanged', null, false);
      }
    },
    getAreaCode () {
      var num = this.contactNum;
      if (num.length !== 10) return;
      return num.substr(0, 3);
    },
    getPrefix () {
      var num = this.contactNum;
      if (num.length !== 10) return;
      return num.substr(3, 3);
    },
    getSuffix () {
      var num = this.contactNum;
      if (num.length !== 10) return;
      return num.substr(6, 4);
    }
  }
};
</script>
